import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { getSlots } from "./thunk";

export const buildWeek = (startDate) => {
    const start = moment(startDate || new Date());
    const week = [];
    for (let i = 0; i < 7; i++) {
        const day = moment(start).add(i, "d");
        week.push({
            day: day.format("dddd"),
            monthDate: day.format("MMM D"),
            monthDate_jp: day.format("MMM Do"),
            date: day.format("YYYY-MM-DD"),
        });
    }
    return week;
};

const InitialState={
    type:null,
    loading: false,
    error: false,
    timeSlots: null,
    disabledDates: null,
    enabledDate: null,
    week: null,
    selectedDateIndex: -1,
    selectDate: new Date(),
    selectedSlotIndex: {
        morning: -1,
        noon: -1,
        evening: -1
    }
};

const calendarSlice= createSlice({
    name:"Calendar",
    initialState: InitialState,
    reducers: {
        // setDoctor(state, action) {
        //     state.doctor = action.payload
        // }
        setCalendarData(state, {payload}) {
            state.timeSlots = payload.timeSlots || state.timeSlots;
            state.disabledDates = payload.disabledDates || state.disabledDates;
            state.enabledDate = payload.enabledDate || state.enabledDate;
            // return state;
        },
        setCalendarWeek(state, {payload}) {
            state.week = payload.week;
            state.timeSlots = null;
            state.selectedSlotIndex = {
                morning: -1,
                noon: -1,
                evening: -1
            }
            state.selectedTime = null;
            state.selectedDateIndex = -1;
        },
        setSlot(state, {payload}) {
            state.selectedSlotIndex = payload.selectedSlotIndex || state.selectedSlotIndex;
            state.selectedTime = payload.selectedTime || state.selectedTime;
        },
        resetCalendar(state, action) {
            return InitialState;
        },
        setSelectDate(state, action) {
            state.selectDate = action.payload || new Date();
        }
    },
    extraReducers: (builder) => {
        // get facilities
        builder.addCase(getSlots.pending, (state, action) => {
            const payload = action?.meta?.arg ?? {};
            state.loading = true;
            const requestedIndex =
                payload.selectedDateIndex ?? payload.selected_date_index ?? 0;
            state.selectedDateIndex = state.week ? requestedIndex : -1;
            state.timeSlots = null;
            state.selectedTime = null;
            state.selectedSlotIndex = {
                morning: -1,
                noon: -1,
                evening: -1
            };
        })
        .addCase(getSlots.fulfilled, (state,{payload})=>{
            state.loading=false;
            state.timeSlots = payload.timeSlots || state.timeSlots;
            state.type = payload.type || state.type;
        })
        .addCase(getSlots.rejected, (state,{payload})=>{
            state.loading = false;
            state.services = [];
            state.error = true;
            state.message=payload;
        });
    },
});

export const { setCalendarData, setCalendarWeek, setSlot, resetCalendar, setSelectDate } = calendarSlice.actions;
export default calendarSlice.reducer;